import React from 'react';

interface StatBoxProps {
  label: string;
  value: string | number;
}

const GRADIENTS = [
  'from-sky-400 to-blue-500',
  'from-pink-400 to-rose-500',
  'from-amber-400 to-orange-500',
  'from-emerald-400 to-green-500',
  'from-violet-400 to-purple-500',
  'from-cyan-400 to-teal-500',
];

// Same label -> same color everywhere (e.g. "Score" is always the same bubble).
const gradientFor = (label: string) => {
  let h = 0;
  for (const ch of label.toLowerCase()) h = (h * 31 + ch.charCodeAt(0)) >>> 0;
  return GRADIENTS[h % GRADIENTS.length];
};

const StatBox: React.FC<StatBoxProps> = ({ label, value }) => (
  <div className={`flex flex-col items-center px-4 py-2 min-w-[88px] rounded-2xl bg-gradient-to-br ${gradientFor(label)} text-white shadow-md ring-2 ring-white/70`}>
    <span className="text-[11px] font-extrabold uppercase tracking-wider text-white/90">{label}</span>
    {/* keyed on the value so it pops each time the number changes */}
    <span key={String(value)} className="fun-pop text-3xl font-black leading-tight drop-shadow-sm">{value}</span>
  </div>
);

export default StatBox;
